import { scrollTop } from "../helpers/scrollTop";

const toTop = document.querySelector(".toTop");

export function toggleToTop() {
    toTop.hidden = window.scrollY < 300;
    toTop.addEventListener("click", scrollTop);
}
